import { render, staticRenderFns } from "./WQtypeText.vue?vue&type=template&id=6c877f2e&"
import script from "./WQtypeText.vue?vue&type=script&lang=ts&"
export * from "./WQtypeText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports